import { faPencil, faPlus, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton, HeadingItem, SplitCard } from 'components';
import { TripContext } from 'contexts';
import React, { FC, Fragment, useContext } from 'react';
import { EquipmentShortReason, EquipmentType, StopEquipment } from 'services/types';
import { IconOptions } from 'types';
import { EQUIPMENT_MAX_QUANTITY } from 'utils';
import './equipment-card.scss';

type Props = {
    equipmentTypeId: number,
    stopId: number | undefined,
    onQuantityOutAdjusted: (id: number, quantity: number) => void,
    onClickButton: (id: number) => void,
    onQuantityInAdjusted?: (id: number, quantity: number) => void
}

export const EquipmentCard: FC<Props> = ({ equipmentTypeId, stopId, onQuantityOutAdjusted, onClickButton, onQuantityInAdjusted }) => {
    const tripContext = useContext(TripContext)
    const stopEquipments: StopEquipment[] = tripContext.stopEquipments.filter(se => se.stopId === stopId) ?? []
    const equipmentType: EquipmentType = tripContext.equipmentTypes.find(et => et.id === equipmentTypeId) ?? {} as EquipmentType
    const equipment: StopEquipment = stopEquipments.find(equipment => equipment.equipmentTypeId == equipmentTypeId) ?? {} as StopEquipment
    const palletShortReason: EquipmentShortReason = equipment && (tripContext.equipmentShortReasons.find(reason => reason.id == equipment.equipmentShortReasonId) ?? {} as EquipmentShortReason)

    let headerIcon = (): IconOptions | undefined => {
      let isNotComplete = (equipmentType.isShortReasonRequired && equipment.quantityOut! < equipment.quantityIn && equipment.equipmentShortReasonId == null) || equipment.quantityOut! > EQUIPMENT_MAX_QUANTITY
        let icon: IconOptions | undefined = isNotComplete ? { icon: faTimesCircle, color: '#EB5757', size: '2x' } : undefined
        return icon
    }

    return (
        <div className={'card-material'}>
            <HeadingItem text={equipmentType.description} rightHandIcon={headerIcon()} />
            <SplitCard
                id={equipmentType.id}
                leftSideQty={equipment ? equipment.quantityIn : 0}
                rightSideQty={(equipment && equipment.quantityOut != null) ? equipment.quantityOut! : 0}
                leftSideHeaderText={"In"}
                rightSideHeaderText={"Return"}
                onLeftQuantityAdjusted={equipmentType.isDeliveredInEditable ? (id, quantity) => onQuantityInAdjusted && onQuantityInAdjusted(id as number, quantity) : undefined}
                onQuantityAdjusted={(id, quantity) => onQuantityOutAdjusted(id as number, quantity)}
                leftSideMaxValue={EQUIPMENT_MAX_QUANTITY}
                rightSideMaxValue={EQUIPMENT_MAX_QUANTITY}
            />
            {(equipmentType.isShortReasonRequired && equipment.quantityOut! < equipment.quantityIn) &&
                <div className={'equipment-card-action-button'}>
                    <ActionButton
                        icon={equipment.equipmentShortReasonId ? faPencil : faPlus}
                        iconSize={'1x'}
                        buttonText={equipment.equipmentShortReasonId ? 'Edit Reason' : 'Add Reason'}
                        buttonColor={equipment.equipmentShortReasonId ? '#F2994A' : '#EB5757'}
                        buttonWidth={'125px'}
                        onClick={() => onClickButton(equipment.id)}
                    />
                </div>
            }
            {equipment.equipmentShortReasonId != null &&
                <Fragment>
                    <div className={'equipment-card-reason-heading'}>Reason</div>
                    <div className={'equipment-card-reason-text'}>{equipment.shortComment ?? palletShortReason.description}</div>
                </Fragment>
            }
        </div>
    )
}